import { BaseContainerModel } from '../../base-container.model';
import { Bl_inv_stock_take_session_record_RowClass } from '../../../dbschema/bl_inv_stock_take_session_record.model';

export class StockTakeSessionRecordModel extends BaseContainerModel {
  bl_inv_stock_take_session_record: Bl_inv_stock_take_session_record_RowClass = new Bl_inv_stock_take_session_record_RowClass();
}
